import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';

export const PaginationComponent = ({ activePage, itemsCountPerPage, totalItemsCount, onPageChange }) => {
  const startIdx = (activePage - 1) * itemsCountPerPage + 1;
  const endIdx = activePage === Math.ceil(totalItemsCount / itemsCountPerPage) ? totalItemsCount : (activePage * itemsCountPerPage);

  return (
    <div className='o-rtable o-rtable--bordered o-rtable__footer align-justify'>
      <div className='o-rtable__cell--pagination u-txt--pagination'>
        <b>{startIdx}</b> to <b>{endIdx}</b> of <b>{totalItemsCount}</b>
      </div>
      <div className='o-rtable__cell--pagination'>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItemsCount}
          pageRangeDisplayed={5}
          onChange={onPageChange}
          innerClass='o-pagination'
          itemClass='o-pagination__item'
          activeClass='o-pagination__item--active'
          disabledClass='u-disabled'
          prevPageText={<i className='fa fa-angle-left cs-txt--sp-blue'></i>}
          firstPageText={<i className='fa fa-angle-double-left cs-txt--sp-blue'></i>}
          lastPageText={<i className='fa fa-angle-double-right cs-txt--sp-blue'></i>}
          nextPageText={<i className='fa fa-angle-right cs-txt--sp-blue'></i>}
        />
      </div>
    </div>
  );
}

PaginationComponent.propTypes = {
  activePage: PropTypes.number.isRequired,
  itemsCountPerPage: PropTypes.number.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
}

const TableFooter = ({ meta, onPageChange }) => {
  return (
    <PaginationComponent
      activePage={meta.page}
      itemsCountPerPage={meta.per}
      totalItemsCount={meta.totalCount}
      onPageChange={onPageChange}
    />
  );
}

TableFooter.propTypes = {
  meta: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
}

export default TableFooter;
